export default __webpack_public_path__ + "static/media/shuffle.48206bb0.svg";